import { useSetRecoilState } from "recoil";
import { APIS } from "../constants";
import { GeoId } from "../types/geo.types";
import { useFetchWrapper, useHandleError } from "../helpers";
import { compareListLengthState, compareListState, stackRankState } from "../states";

const useCompareService = () => {
    const fetchWrapper = useFetchWrapper();
    const { getErrorMsg } = useHandleError();
    const setCompareList = useSetRecoilState(compareListState);
    const setStackRankData = useSetRecoilState(stackRankState);
    const setCompareListLength = useSetRecoilState(compareListLengthState);

    const normalizeGeoId = (geoId: any): GeoId =>
        geoId == 1 || geoId === '1' ? 'EW-IN-IND-22-0' : geoId;

    const normalizePayload = (payload: any) => {
        if (!payload) return payload;
        const result = { ...payload };
        if (result.geoId != null) result.geoId = normalizeGeoId(result.geoId);
        if (result.geocode != null) result.geocode = normalizeGeoId(result.geocode);
        if (result.geoCode != null) result.geoCode = normalizeGeoId(result.geoCode);
        if (result.parentgeoId != null) result.parentgeoId = normalizeGeoId(result.parentgeoId);
        return result;
    };

    const getCompareList = async () => {
        try {
            const response = await fetchWrapper.get(APIS.COMPARE.GET_COMPARE_LIST);
            if (response) {
                setCompareList(response);
                setCompareListLength({
                    districtListLength: response.districts.length,
                    subDistrictListLength: response.subdistricts.length,
                    pincodesListLength:response.pincodes.length,
                    villagessListLength:response?.villages?.length
                })
            }
        } catch (error) {
            getErrorMsg(error);
        }
    }

    const postCompreList = async (payload: any) => {
        try {
            const response = await fetchWrapper.post(APIS.COMPARE.GET_COMPARE_LIST, payload);
            if (response) {
                setCompareList(response);
                setCompareListLength({
                    districtListLength: response.districts.length,
                    subDistrictListLength: response.subdistricts.length,
                    pincodesListLength: response.pincodes.length,
                    villagessListLength:response?.villages?.length
                })
            }
        } catch (error) {
            getErrorMsg(error);
        }
    }

    const getStackRank = async () => {
        try {
            const response = await fetchWrapper.get(APIS.COMPARE.GET_STACKRANK);
            if (response) {
                setStackRankData({
                    State:  response?.options || [],
                    Districts: response?.options || [],
                    Subdistricts: response?.options?.filter((opt: any) => opt.key !== 'ctv') || [],
                    PinCode: response?.options?.filter((opt: any) => opt.key !== 'ctv') || [],
                    Villages: response?.options?.filter((opt: any) => opt.key !== 'ctv') || [],
                    Branches: response?.options?.filter((opt: any) => opt.key !== 'ctv') || [],
                    Partners: response?.options?.filter((opt: any) => opt.key !== 'ctv') || [],
                    'Relationship Managers': response?.options?.filter((opt: any) => opt.key !== 'ctv') || [],
                });
            }
        } catch (error) {
            getErrorMsg(error);
        }
    }

    const getComparisionBarGraphData = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_BAR_GRAPH, normalizePayload(payload));
    }

    const getPoIGrowthGraph = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_PoI_GROWTH, normalizePayload(payload));
    }

    const getScatterGraphData = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_SCATTER_GRAPH, normalizePayload(payload));
    }

    const getStackBarLineGraph = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_STACK_BAR_LINE_GRAPH, normalizePayload(payload));
    }

    const getCompareTableData = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_COMPARE_TABLE, normalizePayload(payload));
    }

    const getStackDropdownData = async (level: number) => {
        return fetchWrapper.get(`${APIS.COMPARE.GET_STACK_GRAPH_DROPDOWN}?lvl=${level}`);
    }

    const getSubCatGrowthGraph = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_SUB_CAT_GROWTH, normalizePayload(payload));
    }

    const getPoiBarGraphDropdown = async () => {
        return fetchWrapper.get(APIS.COMPARE.GET_BAR_GRAPH_DROPDOWN);
    }

    const getAllVillages = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_ALL_VILLAGES, normalizePayload(payload));
    }

    const getAllCatchments = async (payload: any) => {
        return fetchWrapper.post(APIS.COMPARE.GET_ALL_CATCHMENTS, normalizePayload(payload));
    }

    const getTopDistricts = async (geoCode: GeoId, currency: string, mbp?: boolean) => {
        geoCode = normalizeGeoId(geoCode);
        return fetchWrapper.get(`${APIS.COMPARE.GET_TOP_DISTRICTS}?geo-code=${geoCode}&curr=${currency}${mbp ? '&mbp=true' : ""}`);
    }

    const getComparisonTypes = async () => {
        return fetchWrapper.get(APIS.COMPARE.GET_COMPARISON_TYPES);
    }
    return (
        {
            getCompareList,
            getStackRank,
            postCompreList,
            getComparisionBarGraphData,
            getPoIGrowthGraph,
            getScatterGraphData,
            getStackBarLineGraph,
            getCompareTableData,
            getStackDropdownData,
            getSubCatGrowthGraph,
            getPoiBarGraphDropdown,
            // getComparisionBarGraphData,
            getAllVillages,
            getAllCatchments,
            getTopDistricts,
            getComparisonTypes,

        }

    );
}

export { useCompareService };